export default __webpack_public_path__ + "static/media/juli 2023 avond met snackmobiel-2.673f4ff6.jpg";